// extracted by mini-css-extract-plugin
module.exports =  {"root":"TSDcLKUpswO59htRnKi5","body":"BqRUkswJLROH1tnL6UGU","heading":"bmxFH7eTquLXuqE8pW8J","list":"NoezgJkW9cpHgZUPaU92","noResults":"HuRTVww7ZajcB9WnbrHl"};